import { useNavigationContext } from '3-foundation/Navigation/NavigationContext';
import { PageContext } from '3-foundation/PageContent/PageContext';
import { useContext } from 'react';
import { UI_Breadcrumb } from 'ui/components/2-molecules/Navigation/Breadcrumb/Breadcrumb';

export const Breadcrumb = () => {
	const navContext = useNavigationContext();
	const pageContext = useContext(PageContext);

	const breadcrumbItems = navContext?.getBreadcrumb({ currentUrl: pageContext.path, includeRootItem: true });
	if (!breadcrumbItems) return null;

	return (
		<UI_Breadcrumb
			breadcrumbItems={breadcrumbItems.map((item) => {
				return { title: item.title && item.title !== '' ? item.title : `[${item.name}]`, url: item.url };
			})}
		/>
	);
};
